import { CommonModule } from '@angular/common';
import { Component, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SingleCardModule } from 'src/app/layouts';
import { Router } from '@angular/router';

@Component({
    selector: 'unauthenticated-content',
    template: `
    <single-card [title]="title" [description]="description">
      <router-outlet></router-outlet>
    </single-card>
  `,
    styles: [
        `
      :host {
        width: 100%;
        height: 100%;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnauthenticatedContentComponent {
  constructor(private router: Router) {}

  get description() {
    const path = this.router.url.split('/').at(-1);
    switch (path) {
      case 'reset-password':
        return 'Please enter the email address that you used to register, and we will send you a link to reset your password via Email.';
      default:
        return '';
    }
  }

  get title() {
    const path = this.router.url.split('/').at(-1);
    switch (path) {
      case 'login':
        return 'Sign In';
      case 'reset-password':
        return 'Reset Password';
      case 'create-account':
        return 'Sign Up';
      case 'change-password':
        return 'Change Password';
      default:
        return '';
    }
  }
}
@NgModule({
  imports: [CommonModule, RouterModule, SingleCardModule],
  declarations: [UnauthenticatedContentComponent],
  exports: [UnauthenticatedContentComponent],
})
export class UnauthenticatedContentModule {}
